"use strict";

exports.__esModule = true;
var _DefaultPageSize = require("./DefaultPageSize");
Object.keys(_DefaultPageSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DefaultPageSize[key]) return;
  exports[key] = _DefaultPageSize[key];
});